<template>
  <div>
    <template v-for="(item,index) in newData">
      <drag-node
        :model='item'
        :allowDrag='allowDrag'
        :allowDrop='allowDrop'
        :depth='increaseDepth'
        :defaultText='defaultText'
        :disableDBClick='disableDBClick'
        :key='index'
      ></drag-node>
    </template>
  </div>
</template>

<script>
import DragNode from './DragNode'
export default {
  name: 'DragTree',
  props: {
    data: Array,
    allowDrag: {
      type: Function,
      default: () => true
    },
    allowDrop: {
      type: Function,
      default: () => true
    },
    defaultText: {
      // 노드가 추가 될 때 표시되는 기본 텍스트.
      type: String,
      default: 'New Node'
    },
    depth: {
      type: Number,
      default: 0
    },
    disableDBClick: {
      // 새 항목을 추가하려면 두 번 클릭을 비활성화하십시오.
      type: Boolean,
      default: false
    }
  },
  computed: {
    increaseDepth () {
      return this.depth + 1
    },
    newData: {
      // getter
      get () {
        return this.data
      },
      // setter
      set (newValue) {
        // "깨끗한"참조 객체를 가지려면 원래 속성의 모든 값을 제거하십시오.
        let length = this.data.length
        for (let i = 0; i < length; i++) {
          this.data.shift(i)
        }
        // 그런 다음 콘솔에 오류를보고하지 않도록 개체 딥 복사 (대상에 대한 참조 반환)
        this.data = Object.assign(this.data, newValue)
      }
    }
  },
  methods: {
    emitCurNodeClicked (model, component) {
      this.$emit('current-node-clicked', model, component)
    },
    emitDrag (model, component, e) {
      this.$emit('drag', model, component, e)
    },
    emitDragEnter (model, component, e) {
      this.$emit('drag-enter', model, component, e)
    },
    emitDragLeave (model, component, e) {
      this.$emit('drag-leave', model, component, e)
    },
    emitDragOver (model, component, e) {
      this.$emit('drag-over', model, component, e)
    },
    emitDragEnd (model, component, e) {
      this.$emit('drag-end', model, component, e)
    },
    emitDrop (model, component, e) {
      this.$emit('drop', model, component, e)
    }
  },
  components: {
    DragNode
  }
}
</script>

